import { useTranslation } from "react-i18next";
import React, { useState, useEffect, useMemo } from 'react';
import OneCard from 'Components/Personal/OneCard';
import './CardList.css';
export default function CardList({
  profile,
  profileLoading
}) {
  const {
    t
  } = useTranslation();
  console.log('CardList profile: ', profile); // Build an effective profile that guarantees Personal exists when Work is present
  // Sort cards by order property to match profile screen ordering

  const effectiveProfile = useMemo(() => {
    if (!profile || !Array.isArray(profile.cards)) return profile;

    // Temporarily filter out Public card
    const nonPublicCards = profile.cards.filter(c => (c.name || '').toLowerCase() !== 'public');

    // Sort cards by order property (same as profile screen)
    const sortedCards = [...nonPublicCards].sort((a, b) => {
      const orderA = a.order !== undefined ? a.order : 999;
      const orderB = b.order !== undefined ? b.order : 999;
      return orderA - orderB;
    });

    if (sortedCards.length === 1 && sortedCards[0] && sortedCards[0].name === 'Work') {
      const work = sortedCards[0];
      const personalProps = (profile.properties || []).filter(p => ['givenName', 'familyName', 'emailAddresses', 'phoneNumbers'].includes(p.name));
      const personalCard = {
        objectId: (work.objectId || work.id || 'work_card_tmp').replace('work_card_', 'personal_card_'),
        name: 'Personal',
        properties: personalProps,
        order: 1,
        public: false,
        defaultCard: false
      }; // Ensure Personal comes before Work if Work has higher order

      const cardsWithPersonal = [personalCard, work].sort((a, b) => {
        const orderA = a.order !== undefined ? a.order : 999;
        const orderB = b.order !== undefined ? b.order : 999;
        return orderA - orderB;
      });
      return { ...profile,
        cards: cardsWithPersonal
      };
    }

    return { ...profile,
      cards: sortedCards
    };
  }, [profile]); // Move useState to the top, before any conditional returns

  const [activeCard, changeCard] = useState(() => {
    if (effectiveProfile && effectiveProfile.cards && effectiveProfile.cards.length > 0) {
      const firstCard = effectiveProfile.cards[0];
      return firstCard.objectId || firstCard.id || firstCard.name || 'fallback-0';
    }

    return null;
  }); // Keep active card valid when cards change

  useEffect(() => {
    if (!effectiveProfile || !effectiveProfile.cards || effectiveProfile.cards.length === 0) return;
    const ids = effectiveProfile.cards.map((c, i) => c.objectId || c.id || c.name || `fallback-${i}`);

    if (!ids.includes(activeCard)) {
      changeCard(ids[0]);
    }
  }, [effectiveProfile, activeCard]); // Handle loading state

  if (profileLoading) {
    return <div>{t("Loading profile...")}</div>;
  } // Handle missing profile or cards


  if (!effectiveProfile || !effectiveProfile.cards || effectiveProfile.cards.length === 0) {
    return <div>{t("No cards available. Please add some properties to your profile first.")}</div>;
  } // Segmented control modern design


  const TabBar = () => {
    const {
      t
    } = useTranslation();
    return <div className="segmented-control-container">
            <div className="segmented-control">
                {effectiveProfile.cards.map((card, index) => {
          if (!card) return null;
          const id = card.objectId || card.id || card.name || `fallback-${index}`;
          const isActive = activeCard === id;
          return <button key={id} onClick={() => changeCard(id)} className={`segment-button ${isActive ? 'active' : ''}`} id={`segment-${index}`}>
                            <span className="segment-icon">
                                {card.name === 'Personal' ? '👤' : card.name === 'Work' ? '💼' : '📇'}
                            </span>
                            <span className="segment-label">{card.name ? t(card.name) : t('Card')}</span>
                        </button>;
        })}
            </div>
        </div>;
  };

  return <div className="card-list-wrapper">
            <TabBar />
            <div className="card-content-wrapper">
                <OneCard profile={effectiveProfile} cardId={activeCard} profileLoading={profileLoading} />
            </div>
        </div>;
}